'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _OMGenericSelect = require('../OMGenericSelect/OMGenericSelect');var _OMGenericSelect2 = _interopRequireDefault(_OMGenericSelect);
var _OMOptionTypeDropdown = require('./OMOptionTypeDropdown.scss');var _OMOptionTypeDropdown2 = _interopRequireDefault(_OMOptionTypeDropdown);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

OMOptionTypeDropdown = function (_Component) {_inherits(OMOptionTypeDropdown, _Component);function OMOptionTypeDropdown() {var _temp, _this, _ret;_classCallCheck(this, OMOptionTypeDropdown);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      pristine: true }, _this.


    handleChange = function (_ref) {var value = _ref.value;
      if (_this.state.pristine) {
        _this.setState({ pristine: false });
      }
      _this.props.handleChange(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);}OMOptionTypeDropdown.prototype.

  render = function render() {var _cx;
    return (
      _react2.default.createElement(_OMGenericSelect2.default, {
        options: this.props.options,
        value: this.props.value,
        onChange: this.handleChange,
        className: (0, _classnames2.default)(
        _OMOptionTypeDropdown2.default[this.props.className], (_cx = {}, _cx[
        _OMOptionTypeDropdown2.default.pristine] = this.props.value && this.state.pristine, _cx)) }));



  };return OMOptionTypeDropdown;}(_react.Component);exports.default = OMOptionTypeDropdown;


OMOptionTypeDropdown.propTypes = {
  options: _propTypes2.default.array,
  value: _propTypes2.default.oneOfType([
  _propTypes2.default.string,
  _propTypes2.default.object,
  _propTypes2.default.bool]),

  handleChange: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMOptionTypeDropdown/OMOptionTypeDropdown.js
// module id = 2752
// module chunks = 0